import parsePhoneNumber from 'libphonenumber-js'

export const phone = (v: string): string => {
  const phoneNumber = parsePhoneNumber(v, 'JP')
  return phoneNumber.format('NATIONAL')
}

export const phoneURI = (v: string): string => {
  const phoneNumber = parsePhoneNumber(v, 'JP')
  return phoneNumber.format('RFC3966')
}
